import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { BottomNavigation } from '../components/BottomNavigation';
import { Header } from '../components/Header';
import { Loader } from '../components/Loader';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    // Имитируем загрузку данных
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div 
      className="flex flex-col min-h-screen w-full bg-tg-bg box-border fixed top-0 left-0 right-0 bottom-0"
    >
      <Header />
      <main 
        className="flex flex-col flex-1 w-full overflow-y-auto overflow-x-hidden pt-2 pb-[72px] bg-tg-bg box-border mt-auto"
        style={{
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }}
      >
        <style>{`
          main::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        <div 
          className="flex-1 p-3 w-full box-border bg-tg-bg"
          style={{
            paddingLeft: 'calc(12px + var(--tg-safe-area-inset-left, 0px))',
            paddingRight: 'calc(12px + var(--tg-safe-area-inset-right, 0px))',
            paddingBottom: 'calc(12px + var(--tg-safe-area-inset-bottom, 0px))'
          }}
        >
          {isLoading ? <Loader /> : children}
        </div>
      </main>
      <nav 
        className="fixed left-0 right-0 bottom-0 z-[100] bg-tg-bg box-border"
        style={{
          paddingBottom: 'var(--tg-safe-area-inset-bottom, 0px)',
          paddingLeft: 'var(--tg-safe-area-inset-left, 0px)',
          paddingRight: 'var(--tg-safe-area-inset-right, 0px)'
        }}
      >
        <BottomNavigation />
      </nav>
    </div>
  );
} 